// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2H_wv","colCheckbox":"styles_colCheckbox__3Grbr"};